export default class CancelableRequests {
  xhrPool: Array<any>;
  cancelableParams: any;
  constructor() {
    this.xhrPool = [];
    this.cancelableParams = {
      beforeSend: jqXHR => {
        this.xhrPool.push(jqXHR);
      },
      complete: jqXHR => {
        var index = this.xhrPool.indexOf(jqXHR);
        if (index > -1) {
          this.xhrPool.splice(index, 1);
        }
      }
    };
  }

  cancelAllRequests() {
    for (const jqXHR of this.xhrPool) {
      jqXHR.abort();
    }
  }
}
